export const renameFilterChildren = ({children: filterChildren, ...filterProps}) => ({filterChildren, ...filterProps});
